import React, { Component } from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';
import { spring, value } from 'popmotion';

import Bullets from './Bullets';
import { Wrapper } from './elements';

const VELOCITY_THRESHOLD = 600;
const DISTANCE_PERCENTILE_THRESHOLD = 0.3;

function childrenBox(root, index) {
  const rootWidth = root.clientWidth;

  const el = root.children[index];
  return {
    offset: el.offsetLeft - (rootWidth - el.offsetWidth) / 2,
    width: el.offsetWidth,
  };
}

class Slider extends Component {
  state = {
    root: null,
    offset: 0,
    width: 0,
  };

  static propTypes = {
    children: PropTypes.node,
    onSlideChange: PropTypes.func,
    onDragStart: PropTypes.func,
    onDragEnd: PropTypes.func,
    onTransitionEnd: PropTypes.func,
    slideIndex: PropTypes.number.isRequired,
  };

  static defaultProps = {
    children: null,
    onSlideChange() {},
    onDragStart() {},
    onDragEnd() {},
    onTransitionEnd() {},
  };

  static getDerivedStateFromProps({ slideIndex }, { root }) {
    return root ? childrenBox(root, slideIndex) : null;
  }

  x = value(0);

  goToSlide = newSlideIndex => {
    const { children, onSlideChange } = this.props;
    if (newSlideIndex >= 0 && newSlideIndex < children.length) {
      onSlideChange(newSlideIndex);
    }
  };

  goToPreviousSlide = () => {
    const { slideIndex } = this.props;
    this.goToSlide(slideIndex - 1);
  };

  goToNextSlide = () => {
    const { slideIndex } = this.props;
    this.goToSlide(slideIndex + 1);
  };

  registerRootElement = root => {
    // eslint-disable-next-line react/destructuring-assignment
    if (root && !this.state.root) {
      const { slideIndex } = this.props;
      this.setState({
        root,
        ...childrenBox(root, slideIndex),
      });
    }
  };

  onDragStart = () => {
    const { onDragStart } = this.props;
    onDragStart();
  };

  onDragEnd = () => {
    const { offset, width } = this.state;
    const { onDragEnd } = this.props;
    const start = -offset;
    const distance = this.x.get() - start;
    const velocity = this.x.getVelocity();

    if (distance !== 0) {
      const threshold = DISTANCE_PERCENTILE_THRESHOLD * width;

      if (distance < -threshold || velocity < -VELOCITY_THRESHOLD) this.goToNextSlide();
      else if (distance > threshold || velocity > VELOCITY_THRESHOLD) this.goToPreviousSlide();
    }

    onDragEnd();
  };

  render() {
    const { offset } = this.state;
    const { children, onTransitionEnd, slideIndex } = this.props;
    const valuesMap = { x: this.x };
    const slideCount = children.length;
    return (
      <Wrapper>
        <SliderAnimated
          id="slide"
          values={valuesMap}
          offset={offset}
          onDragStart={this.onDragStart}
          onDragEnd={this.onDragEnd}
          onPoseComplete={onTransitionEnd}
          poseKey={offset}
          innerRef={this.registerRootElement}
          pose="slide"
          style={{ display: 'flex', height: '100%', width: '100%', flexWrap: 'nowrap' }}
        >
          {children}
        </SliderAnimated>
        <Bullets bulletCount={slideCount} currentBullet={slideIndex} />
      </Wrapper>
    );
  }
}

const SliderAnimated = posed.div({
  draggable: 'x',
  slide: {
    x: ({ offset }) => -offset,
    transition: { ease: 'circOut', duration: 200 },
  },
  dragEnd: {
    // eslint-disable-next-line no-unused-vars
    transition: ({ from, to, velocity, offset }) => {
      return spring({ from, to: -offset, velocity, stiffness: 600, damping: 30 });
    },
  },
});

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider/index.js